import React from "react";

const errorObject=[];
    // [{
    //     message:'3D view of Room is Missing'
    // },
    // {
    //     message: 'Key Plan is Missing'
    // }]
export default class ErrorComponent extends React.Component<any, any>{
    componentDidMount(): void {
        const element =document.getElementById('pageContainer')
        if(element){

        }
    }
    componentWillUnmount(): void {
        const element =document.getElementById('pageContainer');
        if(element) {
        }
    }

    render(){
        return(
            <>
                {errorObject.length
                ?<div className={'errorDivClass'}>
                    <p className={'errorHeader'}>
                        ERRORS IN PAGE:
                    </p>
                    {errorObject.map((error,i)=>{
                        return(
                            <p className={'errorMessage'}>
                                {` ${i+1}.  ${error.message}`}
                            </p>
                        )
                    })}
                </div>
                :null}
            </>
        )
    }

    }
